"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _IntervalFrequencies = require("../consts/IntervalFrequencies");

var _IntervalFrequencyFactory = _interopRequireDefault(require("./IntervalFrequencyFactory"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * @deprecated Use IntervalFrequencyFactory or IntervalFrequencyEnum
 */
var IntervalFrequencyWrapper = /*#__PURE__*/function () {
  function IntervalFrequencyWrapper(frequency) {
    _classCallCheck(this, IntervalFrequencyWrapper);

    _defineProperty(this, "frequency", void 0);

    _defineProperty(this, "intervalFrequency", void 0);

    this.frequency = frequency;
    this.intervalFrequency = _IntervalFrequencyFactory["default"].For(frequency);
  }

  _createClass(IntervalFrequencyWrapper, [{
    key: "addIntervals",
    value: function addIntervals(startDate, operand) {
      return this.intervalFrequency.addIntervals(startDate, operand);
    }
  }, {
    key: "subtractIntervals",
    value: function subtractIntervals(startDate, operand) {
      return this.intervalFrequency.subtractIntervals(startDate, operand);
    }
  }, {
    key: "isBiannualPermutation",
    value: function isBiannualPermutation() {
      return this.intervalFrequency.isBiannualPermutation();
    }
  }, {
    key: "isMonthlyPermutation",
    value: function isMonthlyPermutation() {
      return this.intervalFrequency.isMonthlyPermutation();
    }
  }, {
    key: "isWeeklyPermutation",
    value: function isWeeklyPermutation() {
      return this.intervalFrequency.isWeeklyPermutation();
    }
  }, {
    key: "isLow",
    value: function isLow() {
      return this.intervalFrequency.isLow();
    }
  }, {
    key: "isHigh",
    value: function isHigh() {
      return this.intervalFrequency.isHigh();
    }
  }, {
    key: "hasDueDate",
    value: function hasDueDate() {
      return this.intervalFrequency.hasDueDate();
    }
  }, {
    key: "numberOfEvents",
    value: function numberOfEvents() {
      return this.intervalFrequency.numberOfEvents();
    }
  }, {
    key: "getInterval",
    value: function getInterval(date) {
      var interval = this.intervalFrequency.getInterval(date);

      if (interval) {
        interval.frequency = this.frequency;
      }

      return interval;
    }
    /**
     * @param fullInterval
     * @param startMonth - zero-indexed month to start generating micro-intervals for,
     *  e.g. `6` for CA SWPPP year's start month (July).
     * @param startDay - one-indexed day of month to start generating micro-intervals for,
     *  e.g. startMonth = 2, startDay = 15 for March 15
     */

  }, {
    key: "getMicroIntervals",
    value: function getMicroIntervals(fullInterval) {
      var _this = this;

      var startMonth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var startDay = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
      var intervals = this.intervalFrequency.getMicroIntervals(fullInterval, startMonth, startDay);
      intervals.forEach(function (interval) {
        // eslint-disable-next-line no-param-reassign
        interval.frequency = _this.frequency;
      });
      return intervals;
    }
  }, {
    key: "getStartOfInterval",
    value: function getStartOfInterval(date) {
      var startMonth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var startDay = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
      return this.intervalFrequency.getStartOfInterval(date, startMonth, startDay);
    }
  }, {
    key: "getWarningDateForUpcomingTasks",
    value: function getWarningDateForUpcomingTasks(baseDate) {
      return this.intervalFrequency.getWarningDateForUpcomingTasks(baseDate);
    }
  }, {
    key: "toString",
    value: function toString() {
      return this.intervalFrequency.toString();
    }
  }, {
    key: "valueOf",
    value: function valueOf() {
      return this.intervalFrequency.valueOf();
    }
  }], [{
    key: "NEVER",
    get: function get() {
      return _IntervalFrequencies.IntervalFrequencyEnum.NEVER;
    }
  }, {
    key: "AS_NEEDED",
    get: function get() {
      return _IntervalFrequencies.IntervalFrequencyEnum.AS_NEEDED;
    }
  }, {
    key: "HOUR",
    get: function get() {
      return _IntervalFrequencies.IntervalFrequencyEnum.HOUR;
    }
  }, {
    key: "DAY",
    get: function get() {
      return _IntervalFrequencies.IntervalFrequencyEnum.DAY;
    }
  }, {
    key: "TWICE_WEEK",
    get: function get() {
      return _IntervalFrequencies.IntervalFrequencyEnum.TWICE_WEEK;
    }
  }, {
    key: "WEEK",
    get: function get() {
      return _IntervalFrequencies.IntervalFrequencyEnum.WEEK;
    }
  }, {
    key: "TWICE_MONTH",
    get: function get() {
      return _IntervalFrequencies.IntervalFrequencyEnum.TWICE_MONTH;
    }
  }, {
    key: "MONTH",
    get: function get() {
      return _IntervalFrequencies.IntervalFrequencyEnum.MONTH;
    }
  }, {
    key: "QUARTER",
    get: function get() {
      return _IntervalFrequencies.IntervalFrequencyEnum.QUARTER;
    }
  }, {
    key: "TWICE_BIANNUAL",
    get: function get() {
      return _IntervalFrequencies.IntervalFrequencyEnum.TWICE_BIANNUAL;
    }
  }, {
    key: "BIANNUAL",
    get: function get() {
      return _IntervalFrequencies.IntervalFrequencyEnum.BIANNUAL;
    }
  }, {
    key: "YEAR",
    get: function get() {
      return _IntervalFrequencies.IntervalFrequencyEnum.YEAR;
    }
  }]);

  return IntervalFrequencyWrapper;
}();

exports["default"] = IntervalFrequencyWrapper;